import hero from "./Hero.module.css"
import { useEffect, useState } from "react";
// import Model3D from '../../components/Model3D'

function Hero () {
    const [theme, setTheme] = useState(() => {
        return document.body.getAttribute("data-theme") || "dark";
    });

    useEffect(() => {
        // Listen for theme changes on the body element
        const observer = new MutationObserver(() => {
            const currentTheme = document.body.getAttribute("data-theme");
            if (currentTheme) setTheme(currentTheme);
        });

        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ["data-theme"]
        });

        return () => observer.disconnect();
    }, []);

    return (
        <main id="hero" className={hero.hero}>
            <img 
                src={theme === "dark" ? "/assets/warning-dark.png" : "/assets/warning-light.png"} 
                alt="Fullscreen warning" 
            />
            <h1 className={hero.h1}>KIAN <br/> <span>SEGA[N]TINI</span></h1>
            <div className={hero.container}>
                <h2 className={hero.h2}>UX/UI <br className={hero.mobileBR} /> Designer</h2>
                <h2 className={hero.h2}>since <br className={hero.mobileBR} /> 2019</h2>
            </div>
            {/* <Model3D /> */}
        </main>
    );
}
export default Hero;